import { render, staticRenderFns } from "./CaseTypeSelect.vue?vue&type=template&id=6052be48"
import script from "./CaseTypeSelect.vue?vue&type=script&lang=ts"
export * from "./CaseTypeSelect.vue?vue&type=script&lang=ts"
import style0 from "./CaseTypeSelect.vue?vue&type=style&index=0&id=6052be48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports